import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode } from "vue"
import _imports_0 from './assets/dor-logo.svg'


const _hoisted_1 = {
  id: "root",
  class: ""
}
const _hoisted_2 = { key: 0 }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("img", {
  alt: "Department of Reuse logo",
  src: _imports_0,
  class: "place-self-center w-1/3 mx-auto mt-10"
}, null, -1)
const _hoisted_4 = [
  _hoisted_3
]
const _hoisted_5 = {
  key: 1,
  class: "bg-logo bg-no-repeat bg-cover bg-center"
}
const _hoisted_6 = { class: "bg-gray-50 bg-opacity-95 min-h-screen" }
const _hoisted_7 = /*#__PURE__*/_createElementVNode("footer", { class: "mt-3 fixed -bottom-0 mx-auto w-full pb-2 bg-opacity-90 bg-gray-200" }, [
  /*#__PURE__*/_createElementVNode("p", { class: "text-xs" }, " This is a community effort started by Maria Teresa Baldassarre, Neil Ernst, Ben Hermann, and Tim Menzies. "),
  /*#__PURE__*/_createElementVNode("p", { class: "text-xs" }, [
    /*#__PURE__*/_createTextVNode(" Please feel free to "),
    /*#__PURE__*/_createElementVNode("a", {
      class: "text-blue-600",
      href: "https://github.com/bhermann/DoR"
    }, "comment or contribute on GitHub"),
    /*#__PURE__*/_createTextVNode(". ")
  ])
], -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Navigation = _resolveComponent("Navigation")!
  const _component_router_view = _resolveComponent("router-view")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    ($setup.showSplash)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, _hoisted_4))
      : (_openBlock(), _createElementBlock("div", _hoisted_5, [
          _createVNode(_component_Navigation),
          _createElementVNode("div", _hoisted_6, [
            _createVNode(_component_router_view)
          ]),
          _hoisted_7
        ]))
  ]))
}